module.exports = __webpack_public_path__ + "fonts/Font4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/reusableComponents/AutoGenerateSignature/fonts/Font4.ttf
// module id = 1733
// module chunks = 0